import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Home from './Components/Home/Home';
import Navbar from './Components/Navbar/Navbar';
import Footer2 from './Components/Footer2/Footer2';
import Aboutus from './Components/Aboutus/Aboutus';
import Contact from './Components/Contact/Contact';
import Services from './Components/Services/Services';


function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);

  return null;
}
function App() {
  return (
    <Router>
      <Navbar />
       <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
       <Route path="/aboutus" element={<Aboutus />} />
        <Route path="/contactus" element={<Contact />} />
          <Route path="/services" element={<Services/>}/>
        
      </Routes>
      <Footer2 />
    </Router>
  );
}

export default App;
